import { grey } from '@mui/material/colors';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';

type Props = {
  title: string;
  color: 'success' | 'error';
};
const colorSchema = {
  success: grey[300],
  error: 'error.light',
};

export const OrderProviderExternalErrorsRatioChartHint: React.FC<Props> = ({ title, color }) => {
  return (
    <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
      <Box
        sx={{
          width: '16px',
          height: '16px',
          backgroundColor: colorSchema[color],
        }}
      ></Box>
      <Typography fontSize="12px">{title}</Typography>
    </Box>
  );
};
